import React from 'react'

import { useMediaQueryContext } from '@fourthwall/components'
import { pluralize } from '@fourthwall/utils/dist/string'
import { useCreateProduct } from '@modules/Dashboard/Product/hooks/useCreateProduct'

import type { Incentive as IncentiveType } from '../../../../Recommendations.types'
import { getBonus } from '../../utils'
import { Incentive } from '../Incentive'

type Props = {
  incentive: Extract<IncentiveType, { type: 'CREATE_N_OR_MORE_PRODUCTS' }>
}

export const ProductsIncentive = ({ incentive }: Props) => {
  const { tablet } = useMediaQueryContext()
  const { openCreateProductModal } = useCreateProduct()

  return (
    <Incentive
      type={incentive.type}
      icon="👕"
      label={`Create ${incentive.amountToCreate} ${pluralize(incentive.amountToCreate, 'product', 'products')}`}
      isCompleted={incentive.isCompleted}
      bonus={getBonus(incentive.bonus)}
      button={{
        label: tablet ? 'Create product' : 'Create',
        onClick: openCreateProductModal,
      }}
    />
  )
}
